import isEqual from 'react-fast-compare';
import { RedirectData } from 'types';

type OutsideViewportType = {
	top: boolean;
	left: boolean;
	bottom: boolean;
	right: boolean;
	any: boolean;
	all: boolean;
};

export function areRedirectsEqual(a: Partial<RedirectData>[], b: Partial<RedirectData>[]) {
	if (!a || !b) {
		// if we don't have either side, fall back to react-fact-compare's behavior
		return isEqual(a, b);
	}

	if (a.length !== b.length) {
		return false;
	}

	for (let x = 0; x < a.length; ++x) {
		const left = a[x];
		const right = b[x];

		// default `redirectUrl` to an empty string if not present, which can happen if you empty out the redirect url field
		// in the form - which we still consider the same as the initial state which is an empty string
		const leftRedirect = left.redirectUrl || '';
		const rightRedirect = right.redirectUrl || '';

		if (leftRedirect !== rightRedirect || left.siteId !== right.siteId) {
			return false;
		}
	}

	return true;
}

/**
 * Takes element and returns distance from the top of the screen.
 *
 * @export
 * @param {*} elem
 * @returns
 */
export function getElemDistance(elem) {
	let location = 0;
	if (elem.offsetParent) {
		do {
			location += elem.offsetTop;
			elem = elem.offsetParent;
		} while (elem);
	}
	return location >= 0 ? location : 0;
}

/**
 * Takes element and returns object that outlines which edges are outside the viewport.
 *
 * @export
 * @param {*} elem
 * @returns
 */
export function isOutOfViewport(elem) {
	const bounding = elem.getBoundingClientRect();

	const top = bounding.top < 0;
	const left = bounding.left < 0;
	const bottom = bounding.bottom > (window.innerHeight || document.documentElement.clientHeight);
	const right = bounding.right > (window.innerWidth || document.documentElement.clientWidth);
	const any = top || left || bottom || right;
	const all = top && left && bottom && right;

	const out: OutsideViewportType = { top, left, bottom, right, any, all };

	return out;
}

/**
 * Checks if a string is a valid GUID.
 */
export function isValidGuid(value: string) {
	const regexGuid =
		/^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;
	return regexGuid.test(value);
}

export function isNullOrEmptyGuid(value: string) {
	return value === null || value === '00000000-0000-0000-0000-000000000000';
}

/**
 * Checks if string parameter has a newline character.
 *
 * @export
 * @param {string} str
 * @return {*}
 */
export function hasNewLine(str: string) {
	return !!/\r|\n/.exec(str);
}
